import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/success.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3464c317"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "card"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_3 = {
  "class": "sub-title"
};
var _hoisted_4 = {
  "class": "text"
};
import Activity from '@/common/components/Activity.vue';
import { useNavigation } from '@/common/util/navigation';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _useNavigation = useNavigation(),
      toBack = _useNavigation.toBack,
      toReplace = _useNavigation.toReplace;
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "SubmitSuccessView"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('submitSuccess')), 1), _createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(_unref(t)('submitSuccessDescPrefix')), 1), _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _unref(toReplace)('/feedback');
            })
          }, _toDisplayString(_unref(t)('myFeedback')), 1), _createTextVNode(_toDisplayString(_unref(t)('submitSuccessDescSuffix')), 1)]), _createElementVNode("div", {
            "class": "button",
            onClick: _cache[1] || (_cache[1] =
            //@ts-ignore
            function () {
              return _unref(toBack) && _unref(toBack).apply(void 0, arguments);
            })
          }, _toDisplayString(_unref(t)('gotIt')), 1)])];
        }),
        _: 1
      });
    };
  }
});